import { render, staticRenderFns } from "./TasksContainer.vue?vue&type=template&id=f2b753ea&scoped=true&"
import script from "./TasksContainer.vue?vue&type=script&lang=js&"
export * from "./TasksContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b753ea",
  null
  
)

export default component.exports